<style>

.title{
  text-align: center;
  font-size: 26px;
  padding: 30px 0;
  text-decoration: underline;
}

.item{
  height: 150px;
  text-align: center;
  background-position: center center;
  background-repeat: no-repeat;
  background-origin: border-box;
  background-clip: border-box;
  background-size: cover;
  border-radius: 11px;
  border: 1px black solid;
  margin: 0 5px 0 5px;
}
.item-text{
  margin-top: 58px;
  font-size: 26px;
  font-weight: bold;
  text-shadow: 1px 1px 3px rgba(0,0,0,1);
}
.sub-cat{
  border-left: 1px #333 solid;
  margin: 0 0 40px 14px;
  padding-top: 20px;
}
.sub-item{
  height: 150px;
  text-align: center;
  background-position: center center;
  background-repeat: no-repeat;
  background-origin: border-box;
  background-clip: border-box;
  background-size: cover;
  border-radius: 11px;
  border: 1px black solid;
  margin: 0 5px 20px 14px;
}
.sub-item-text{
  margin-top: 58px;
  font-size: 26px;
  font-weight: bold;
  text-shadow: 1px 1px 3px rgba(0,0,0,1);
}
.sub-item-text-selected{
  margin-top: 4px;
}

.margin{
  height: 20px;
}

.selected{
  box-shadow: 0 0 10px #7DE0FF;
  border: 3px #7DE0FF solid;
  height: 146px;
}
.check{
  /* height: 50px; */
  text-align: right;
}
.icon-check{
  font-size: 50px;
  color: #7DE0FF;
  text-shadow: 1px 1px 6px #555;
}

</style>

{#if items.length > 0}
  {#each items as item, itemIndex }
    
    {#if item.h == 0}
      <div class="title">{item.t}</div>
    {/if}
    
    {#if item.h == 1}
    
    <div class="sub-item {item.s ? 'selected' : ''}" style="background-image: url('/categories/{item.p}.jpg');" on:click="{ () => record(itemIndex, item) }">
            
      <div class="check">
        {#if item.s}
          <i class="icon-check"></i>
        {/if}
      </div>
      <div class="sub-item-text {item.s ? 'sub-item-text-selected' : ''}">{item.t}</div>
            
    </div>

    {/if}
    
    
    <!-- <div class="item" style="background-image: url('/categories/{item.p}.jpg');" on:click="{ () => item.o = !item.o }">
      <div class="item-text">{item.t} +</div>
    </div>
    
    {#if item.o}
      <div class="sub-cat" transition:slide={{ duration: 700 }}>
        {#each item.subCategories as subItem, subItemIndex }
          <div class="sub-item {subItem.s ? 'selected' : ''}" style="background-image: url('/categories/{subItem.p}.jpg');" on:click="{ () => record(itemIndex, subItemIndex, subItem) }">
            
            <div class="check">
              {#if subItem.s}
                <i class="icon-check"></i>
              {/if}
            </div>
            <div class="sub-item-text {subItem.s ? 'sub-item-text-selected' : ''}">{subItem.t}</div>
                  
          </div>
        {/each}
      </div>
    {:else}
      <div class="margin"></div>
    {/if} -->
  {/each}
{/if}


<script>

import { createEventDispatcher } from 'svelte';
const dispatch = createEventDispatcher();

import { slide } from "svelte/transition";

export let items = [];


function record(itemIndex, item) {
  dispatch("selected", {itemIndex: itemIndex, item: item});
}

</script>